import React from 'react';
const ClientServiceStep = (props) => {
    const content = () => {
        return (React.createElement(React.Fragment, null,
            props.title && React.createElement("h4", { className: "cs-step_title font__title mb-32" }, props.title),
            props.text && React.createElement("div", { className: "cs-step_text mb-12", dangerouslySetInnerHTML: { __html: props.text } }),
            props.link && (React.createElement("a", { className: "button button--tertiary", href: props.link },
                React.createElement("span", null, props.cta)))));
    };
    return props.isSlide ? (React.createElement("div", { className: "cs-step_slide" },
        props.name && React.createElement("h3", { className: "cs-step_title font__title mb-32" }, props.name),
        React.createElement("div", null, content()))) : (React.createElement("div", { className: "row cs-step_row" },
        React.createElement("div", { className: "inner-col-24 inner-col-lg-2" }, props.name && React.createElement("h3", { className: "cs-step_name font__title" }, props.name)),
        React.createElement("div", { className: "inner-col-24 inner-col-lg-8" }, content())));
};
export default ClientServiceStep;
